var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root support"},[_c('lx-button',{staticClass:"btn",attrs:{"theme":"blue-medium","loading":_vm.isZendeskLoading},on:{"click":function($event){return _vm.openZendesk('Landing')}}},[_vm._v("?")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }